import React from 'react';

const Hero = () => {
  return (
    <section className="h-screen flex items-center justify-center relative overflow-hidden" aria-label="Hero section">
      <div className="absolute inset-0 bg-radial-gradient from-gradientStart to-gradientEnd -z-10" aria-hidden="true"></div>
      
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          
          <h1 className="text-6xl font-bold leading-tight mb-6">
            <span className="bg-gradient-to-r from-[#00A896] to-[#F9C784] bg-clip-text text-transparent">Intelligence designed<br/>around </span>
            <span className="text-purple-500">human connection.</span>
          </h1>
          
          <p className="text-2xl mb-10 text-lightText leading-relaxed max-w-2xl mx-auto">
            Experience the future of business-customer interactions.
          </p>
          
        </div>
      </div>
    </section>
  );
};

export default Hero;
